import { useEffect, useState } from "react";
import { useGetLinkedAccounts } from "./useGetLinkedAccounts";

// This hook is used to determine the INITIAL linked status of the user's accounts
export const useLinkedAccountsState = () => {
  // State for initial linked status
  const [initialDiscordLinked, setInitialDiscordLinked] = useState(false);
  const [initialXLinked, setInitialXLinked] = useState(false);
  const [isLinkedAccountsCheckComplete, setIsLinkedAccountsCheckComplete] =
    useState(false);

  const { data: linkedAccounts, isLoading: isLinkedAccountsLoading } =
    useGetLinkedAccounts();

  // Effect to determine initial linked status
  useEffect(() => {
    if (
      isLinkedAccountsLoading ||
      !linkedAccounts ||
      isLinkedAccountsCheckComplete
    )
      return;

    const discordInitiallyPresent = linkedAccounts.linked_accounts.some(
      (account) => account.platform === "discord",
    );
    const xInitiallyPresent = linkedAccounts.linked_accounts.some(
      (account) => account.platform === "x",
    );
    setInitialDiscordLinked(discordInitiallyPresent);
    setInitialXLinked(xInitiallyPresent);
    setIsLinkedAccountsCheckComplete(true);
  }, [linkedAccounts, isLinkedAccountsLoading, isLinkedAccountsCheckComplete]);

  return {
    discordLinked: initialDiscordLinked,
    xLinked: initialXLinked,
    isReady: isLinkedAccountsCheckComplete,
  };
};
